const ZIP_CODE_SEPARATING_POINT = 3;
const ZIP_CODE_SEPARATOR = ` `;

export const formatZipCode = (zipCode: string) =>
  zipCode.length > ZIP_CODE_SEPARATING_POINT
    ? `${zipCode.slice(0, ZIP_CODE_SEPARATING_POINT)}${ZIP_CODE_SEPARATOR}${zipCode.slice(ZIP_CODE_SEPARATING_POINT)}`
    : zipCode;
